import { createReducer } from '@reduxjs/toolkit';
import { IModerationHotKeysState as State } from '../types';
import * as actions from '../actions';

const {
  openModerationActiveBar,
  closeModerationActiveBar,
  toggleItem,
  resetAllFilters,
  toggleModerationActiveBar,
  clearAllItems
} = actions;

const initialState: State = {
  isModerationBarActive: false,
  cursor: 0,
  isConfirmationModalOpen: false,
};

const hotKeysReducer = createReducer(initialState, {
  [toggleModerationActiveBar.type]: state => {
    state.isModerationBarActive = !state.isModerationBarActive;
  },
  [openModerationActiveBar.type]: state => {
    state.isModerationBarActive = true;
    state.cursor = 0;
  },
  [clearAllItems.type]: state => {
    state.isModerationBarActive = false;
    state.cursor = 0;
  },
  [toggleItem.type]: (state, { payload: { cursor, checked } }) => {
    state.isModerationBarActive = true;
    state.cursor = cursor || 0;
  },
  [closeModerationActiveBar.type]: state => {
    state.isModerationBarActive = false;
    state.cursor = 0;
  },
  [resetAllFilters.type]: () => initialState
});

export { hotKeysReducer };
